// extracted by mini-css-extract-plugin
module.exports = {"linearGradientSVG":"warningGradient_linearGradientSVG__3ecV5"};